var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAssignmentsEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 50,
  viewBox: "0 0 58 50",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E6EBF0",
  d: "M8 39v7h42v-7h4v7a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-7zM4 4a4 4 0 0 1 4-4h42a4 4 0 0 1 4 4v7h-4V4H8v7H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0DAE1",
  d: "M7.707 30.293a1 1 0 0 1 0 1.414l-4 4a.997.997 0 0 1-1.414 0l-2-2a.999.999 0 1 1 1.414-1.414L3 33.586l3.293-3.293a1 1 0 0 1 1.414 0M45.815 31a2 2 0 1 1 0 4H13a2 2 0 1 1 0-4zM7.707 22.293a1 1 0 0 1 0 1.414l-4 4a.997.997 0 0 1-1.414 0l-2-2a.999.999 0 1 1 1.414-1.414L3 25.586l3.293-3.293a1 1 0 0 1 1.414 0M56 23a2 2 0 1 1 0 4H13a2 2 0 1 1 0-4zM7.707 14.293a1 1 0 0 1 0 1.414l-4 4a.997.997 0 0 1-1.414 0l-2-2a.999.999 0 1 1 1.414-1.414L3 17.586l3.293-3.293a1 1 0 0 1 1.414 0m44.59.707a2 2 0 1 1 0 4H13a2 2 0 1 1 0-4z"
}))));
export default SvgAssignmentsEmpty;